import React from 'react';
import { PhoneIcon, MessageCircleIcon, MailIcon, CalendarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { trackEvent } from '../utils/analytics';
import { AFFILIATION_EN, AFFILIATION_ES, AGENT_DISPLAY_NAME, AGENT_PORTRAIT_URL, AGENT_ROLE_EN, AGENT_ROLE_ES, BRAND_ASSETS_AUTHORIZED, BUSINESS_EMAIL, BUSINESS_EMAIL_HREF, BUSINESS_PHONE_DISPLAY, BUSINESS_PHONE_HREF, LOGO_AVANTI_COLOR, LOGO_VERO_MEDALLION, OFFICIAL_PROFILE_URL, WHATSAPP_URL } from '../data/contact';
import { Reveal } from './Reveal';
export function AgentSection() {
  const {
    lang,
    t
  } = useLanguage();
  const hasPortrait = AGENT_PORTRAIT_URL.length > 0;
  return <section id="agent" className="w-full bg-ivory py-20 lg:py-28" data-id="element-14" data-mp="11wbb5uahe5jq">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-15" data-mp="3rku5g5a17sf8">
        <div className={`grid gap-12 lg:gap-16 ${hasPortrait ? 'lg:grid-cols-12' : ''}`} data-id="element-16" data-mp="3rm58g2vnkw5a">
          {hasPortrait && <Reveal className="lg:col-span-5" data-id="element-17" data-mp="3mo3qxmdvl4vx">
              <figure className="arch-frame-soft h-[420px] w-full sm:h-[520px] lg:h-[620px]" data-id="element-18" data-mp="2g6hr2oybs2ox">
                <img src={AGENT_PORTRAIT_URL} alt={t('Professional portrait of Veronica Gomez Santana.', 'Retrato profesional de Veronica Gomez Santana.')} className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-19" data-mp="2l4t1p1wg2h87" />
              </figure>
            </Reveal>}

          <div className={hasPortrait ? 'lg:col-span-7' : ''} data-id="element-20" data-mp="227rqgzcarkvt">
            <Reveal data-id="element-21" data-mp="1ni3qc1fuqs9o">
              <p className="label-caps text-gold" data-id="element-22" data-mp="1nilvxooemiu9">
                {t('Your Real-Estate Contact', 'Tu Contacto Inmobiliario')}
              </p>

              {BRAND_ASSETS_AUTHORIZED && <img src={LOGO_VERO_MEDALLION} alt="VERO personal brand of Veronica Gomez Santana." className="mt-8 h-auto w-[180px] sm:w-[240px] lg:w-[300px]" width={300} height={300} loading="lazy" decoding="async" data-id="element-23" data-mp="1egmbsni3eyn3" />}

              <h2 className="mt-8 font-display text-[32px] font-semibold uppercase leading-[1.05] tracking-[0.04em] text-midnight sm:text-[40px] lg:text-[46px]" data-id="element-24" data-mp="3bflayt3ohdv2">
                {AGENT_DISPLAY_NAME}
              </h2>
              <p className="label-caps mt-3 text-ink/70" data-id="element-25" data-mp="7xbanjplup8l">
                {lang === 'en' ? AGENT_ROLE_EN : AGENT_ROLE_ES}
              </p>
              <p className="label-caps mt-2 text-ink/70" data-id="element-26" data-mp="3u51cnjr3ncd2">
                {lang === 'en' ? AFFILIATION_EN : AFFILIATION_ES}
              </p>

              {BRAND_ASSETS_AUTHORIZED && <img src={LOGO_AVANTI_COLOR} alt="Avanti Way Realty LLC." className="mt-5 h-auto w-[150px]" width={150} height={30} loading="lazy" decoding="async" data-id="element-27" data-mp="3q5si4co8jagg" />}

              <div className="gold-rule mt-8 w-24" data-id="element-28" data-mp="y7byuu0vb6jf" />

              <p className="mt-7 max-w-xl text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-29" data-mp="y83jj9sxfjux">
                {t('Contact Veronica for additional property information, current availability and private-showing requests.', 'Comunícate con Veronica para solicitar información adicional, consultar disponibilidad o programar una visita privada.')}
              </p>

              <dl className="mt-8 space-y-4" data-id="element-30" data-mp="1hxno281ze5x5">
                <div data-id="element-31" data-mp="1lyhfvcijo4vb">
                  <dt className="label-caps text-ink/55" data-id="element-32" data-mp="1ly7mrg27dhle">{t('Business Phone', 'Teléfono')}</dt>
                  <dd className="mt-1" data-id="element-33" data-mp="1qvzfudel39r6">
                    <a href={BUSINESS_PHONE_HREF} onClick={() => trackEvent('phone_click', {
                    location: 'agent'
                  })} className="font-display text-[26px] font-medium text-midnight transition-colors duration-150 ease-out hover:text-gold" data-id="element-34" data-mp="3nosx8xmb7xsr">
                      {BUSINESS_PHONE_DISPLAY}
                    </a>
                  </dd>
                </div>
                <div data-id="element-35" data-mp="37au569iojxdj">
                  <dt className="label-caps text-ink/55" data-id="element-36" data-mp="37b3vxzbju8ka">{t('Business Email', 'Correo')}</dt>
                  <dd className="mt-1" data-id="element-37" data-mp="32dbr64pt2ryo">
                    <a href={BUSINESS_EMAIL_HREF} onClick={() => trackEvent('email_click', {
                    location: 'agent'
                  })} className="text-[15px] text-midnight underline decoration-gold/60 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold" data-id="element-38" data-mp="2en7ru9jnhedh">
                      {BUSINESS_EMAIL}
                    </a>
                  </dd>
                </div>
              </dl>

              <p className="mt-3 text-[12px] text-ink/60" data-id="element-39" data-mp="1vuvs7ukdsr71">
                Veronica Gomez Santana •{' '}
                {t('Affiliated with Avanti Way Realty LLC', 'Afiliada a Avanti Way Realty LLC')}
              </p>

              <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-40" data-mp="6drus7brz644">
                <a href={BUSINESS_PHONE_HREF} onClick={() => trackEvent('phone_click', {
                location: 'agent_buttons'
              })} className="inline-flex items-center justify-center gap-2 bg-midnight px-5 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-white transition-colors duration-150 ease-out hover:bg-navy" data-id="element-41" data-mp="b7vymhpquy0z">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="u4nhiq1djb4i" />
                  {t('Call Veronica', 'Llamar a Veronica')}
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_click', {
                location: 'agent_buttons'
              })} className="inline-flex items-center justify-center gap-2 bg-gold px-5 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-43" data-mp="k6pto3nffgcf">
                  <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="16hr91i9u7gqj" />
                  {t('Chat on WhatsApp', 'Escribir por WhatsApp')}
                </a>
                <a href={BUSINESS_EMAIL_HREF} onClick={() => trackEvent('email_click', {
                location: 'agent_buttons'
              })} className="inline-flex items-center justify-center gap-2 border border-midnight/25 px-5 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-45" data-mp="wp28hiftrn9z">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-46" data-mp="2d3v32w0cubz0" />
                  {t('Email Veronica', 'Enviar un Correo')}
                </a>
                <a href="#contact" onClick={() => trackEvent('schedule_tour_click', {
                location: 'agent_buttons'
              })} className="inline-flex items-center justify-center gap-2 border border-midnight/25 px-5 py-4 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-47" data-mp="28620ecy9g03h">
                  <CalendarIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="2ufa766qhz66y" />
                  {t('Request a Showing', 'Solicitar una Visita')}
                </a>
              </div>

              <a href={OFFICIAL_PROFILE_URL} target="_blank" rel="noopener noreferrer" className="label-caps mt-6 inline-block text-ink/60 underline decoration-gold/50 underline-offset-4 transition-colors duration-150 ease-out hover:text-midnight" data-id="element-49" data-mp="21p0duoqlnu0i">
                {t('Official Brokerage Profile', 'Perfil Oficial de la Brokerage')}
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}